import { render, staticRenderFns } from "./lookPrescription.vue?vue&type=template&id=6420c2d0&scoped=true"
import script from "./lookPrescription.vue?vue&type=script&lang=js"
export * from "./lookPrescription.vue?vue&type=script&lang=js"
import style0 from "./lookPrescription.vue?vue&type=style&index=0&id=6420c2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6420c2d0",
  null
  
)

export default component.exports